import {
    StyleSheet
} from "react-native";
import type {
    HoverCardTriggerDynamicStyleType
} from "./type";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

export const HOVER_CARD_TRIGGER_VARIANT = "labelMediumSize";

const stylesheet = StyleSheet.create({
    title: {
        textDecorationLine: "underline"
    },
    link: {
        alignSelf: "flex-start",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    anchor: {
        alignSelf: "flex-start"
    },
    stretchedAnchor: {
        alignSelf: "stretch"
    }
});

export const useStyles = ({
    shapeConfigs,
    radiuses,
    spaces
}: HoverCardTriggerDynamicStyleType) => {
    const styles = {
        link: {
            marginHorizontal: -spaces.spacingXxs,
            paddingHorizontal: spaces.spacingXxs,
            ...getCornerStyle({
                radius: radiuses.xs,
                shapeConfigs
            })
        }
    };

    return styles;
};
export default stylesheet;
